export const ErrorIds = {
  INVALID_REQUEST: 3,
  AUTHENTICATION_ERROR: 9,
  AUTHENTICATION_FAILED: 10,
  RESOURCE_NOT_FOUND: 17,
  AGREEMENT_HAS_DEBT: 22,
  LAST_AGREEMENT_TERMINATED: 23,
  INSUFFICIENT_FUNDS: 25,
  USER_HAS_NO_ACTIVE_CREDIT: 26,
  WITHDRAW_NOT_APPROVED: 33,
  CONFLICT: 35,
  ACCESS_DENIED: 38,
  OVERDUE_PAYBACKS_CHARGE_IN_PROGRESS: 41,
  DIRECT_DEBIT_MANDATE_NOT_FOUND: 42,
  NO_ACTIVE_CREDIT_AGREEMENT: 43,
  WITHDRAW_NOT_ALLOWED_USER_BLOCKED: 46,
  DEBT_TRANSFER_TIMEOUT: 48,
  DIRECT_DEBIT_CHARGE_IN_PROGRESS: 52,
  TOO_SOON_ATTEMPT_TO_SEND_MESSAGE: 55,
  WRONG_CODE: 56,
  MAX_VERIFICATION_TRIES_REACHED: 57,
  APPLICATION_NOT_FOUND: 58,
  DOCUMENTS_NOT_SIGNED: 60,
  MOBILE_NOT_VERIFIED: 61,
  PRODUCT_TIER_NOT_SELECTED: 62,
  CODE_EXPIRED: 65,
  MALFORMED_CODE: 66,
  NO_MORE_VERIFICATION_ATTEMPTS_LEFT: 67,
  NO_APPROVED_APPLICATION: 70,
  MAX_ATTEMPTS_REACHED: 72,
  ACCOUNT_UNSUPPORTED: 73,
  UNABLE_TO_VALIDATE: 74,
  OLD_APPLICATION: 76,
  UNDER_MANUAL_APPROVAL: 79,
  USER_BLOCKED: 81,
  EMAIL_MISMATCH: 84,
  WAF_BLOCKED: 89,
  INTERNAL_SERVER_ERROR: 91,
  BANK_ID_API: 92,
  DIRECT_PAYMENT_ORDER_NOT_FOUND: 103,
  DIRECT_PAYMENT_ORDER_EXPIRED: 104,
  DIRECT_PAYMENT_ORDER_DATA_MISSING: 105,
  USER_OWES_INTEREST: 109,
  USER_OWES_PRINCIPAL_AND_INTEREST: 110,
  USERS_LAST_PAYBACK_IS_STILL_PROCESSING: 111,
  WITHDRAW_AMOUNT_PLUS_FEE_HIGHER_THAN_LIMIT: 114,
  WITHDRAW_AMOUNT_GREATER_THAN_MINIMUM: 115,
  WITHDRAW_NOT_APPROVED_USER_BLOCKED_IP: 127,
  REQUIRE_MANUAL_REVIEW: 128,
  APPLICATION_REJECTED_DURING_PRE_SIGNING_CHECKS: 129,
} as const;

export type ErrorId = (typeof ErrorIds)[keyof typeof ErrorIds];

export type ResponseStatus = 400 | 401 | 403 | 404 | 409 | 412;
